import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: "/UserAgreementSst",
  },
  {
    path: '/UserAgreementSst',
    name: 'UserAgreementSst',
    component: () => import('../views/UserAgreementSst.vue'),
    meta: {
      title: "用户协议"
    }
  },
  {
    path: '/UserAgreementZsxt',
    name: 'UserAgreementZsxt',
    component: () => import('../views/UserAgreementZsxt.vue'),
    meta: {
      title: "用户协议"
    }
  },
  {
    path: '/UserAgreementltb',
    name: 'UserAgreementltb',
    component: () => import('../views/UserAgreementltb.vue'),
    meta: {
      title: "用户协议"
    }
  },
  // 安卓 隐私协议   旅途随身听  旅听宝
  {
    path: '/PrivacyAgreementSst',
    name: 'PrivacyAgreementSst',
    component: () => import('../views/PrivacyAgreementSst.vue'),
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: '/PrivacyAgreementltb',
    name: 'PrivacyAgreementltb',
    component: () => import('../views/PrivacyAgreementltb.vue'),
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: '/PrivacyAgreementZsxt',
    name: 'PrivacyAgreementZsxt',
    component: () => import('../views/PrivacyAgreementZsxt.vue'),
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: '/PrivacyAgreementChildZsxt',
    name: 'PrivacyAgreementChildZsxt',
    component: () => import('../views/PrivacyAgreementChildZsxt.vue'),
    meta: {
      title: "儿童隐私协议"
    }
  },
  // ios 隐私协议   旅途随身听  旅听宝
  {
    path: '/PrivacyAgreementIosSst',
    name: 'PrivacyAgreementIosSst',
    component: () => import('../views/PrivacyAgreementIosSst.vue'),
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: '/PrivacyAgreementIosltb',
    name: 'PrivacyAgreementIosltb',
    component: () => import('../views/PrivacyAgreementIosltb.vue'),
    meta: {
      title: "隐私协议"
    }
  },
  // vip服务协议 旅途随身听 旅听宝
  {
    path: '/VIPAgreementSst',
    name: 'VIPAgreementSst',
    component: () => import('../views/VIPAgreementSst.vue'),
    meta: {
      title: "VIP服务协议"
    }
  },
  {
    path: '/VIPAgreementltb',
    name: 'VIPAgreementltb',
    component: () => import('../views/VIPAgreementltb.vue'),
    meta: {
      title: "VIP服务协议"
    }
  },

  // {
  //   path: '/Business',
  //   name: 'Business',
  //   component: () => import('../views/Business.vue'),
  //   meta: {
  //     title: "商务合作"
  //   }
  // },
  {
    path: '/BusinessCooperationSst',
    name: 'BusinessCooperationSst',
    component: () => import('../views/BusinessCooperationSst1.vue'),
    meta: {
      title: "商务合作"
    }
  },
  {
    path: '/BusinessCooperationltb',
    name: 'BusinessCooperationltb',
    component: () => import('../views/BusinessCooperationltb.vue'),
    meta: {
      title: "商务合作"
    }
  },
  {
    path: '/Help',
    name: 'Help',
    component: () => import('../views/Help.vue'),
    meta: {
      title: "帮助"
    }
  },
  {
    path: '/openSourceStatement',
    name: 'openSourceStatement',
    component: () => import('../views/openSourceStatement.vue'),
    meta: {
      title: "开源软件声明"
    }
  },
  {
    path: '/autoRenewServiceAgreement',
    name: 'autoRenewServiceAgreement',
    component: () => import('../views/autoRenewServiceAgreement.vue'),
    meta: {
      title: "旅途随身听会员自动续费服务协议"
    }
  },
  {
    path: '/cancelAutoRenew',
    name: 'cancelAutoRenew',
    component: () => import('../views/cancelAutoRenew.vue'),
    meta: {
      title: "取消会员连续续订"
    }
  }
]

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.VUE_APP_outputDir //productionText productionTest

})

export default router
